import PulsingLoader from "./PulsingLoader"

export const Spinner = () => <PulsingLoader />
